import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CondominiumIndexPage } from './condominium-index';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
	declarations: [
		CondominiumIndexPage,
	],
	imports: [
		ComponentsModule,
		IonicPageModule.forChild(CondominiumIndexPage),
	],
})
export class CondominiumIndexPageModule {}



// WEBPACK FOOTER //
// ./src/pages/condominium-index/condominium-index.module.ts